function installManagementUi({
  Framework,
  locale,
  language,
  components,
  Loading,
  MessageBox,
  Message,
  Notification,
}) {
  locale.use(language);
  components.forEach((component) => Framework.use(component));

  Framework.use(Loading.directive);
  Framework.prototype.$ELEMENT = { size: '', zIndex: 2000 };
  Framework.prototype.$loading = Loading.service;
  Framework.prototype.$msgbox = MessageBox;
  Framework.prototype.$alert = MessageBox.alert;
  Framework.prototype.$confirm = MessageBox.confirm;
  Framework.prototype.$prompt = MessageBox.prompt;
  if (Notification) Framework.prototype.$notify = Notification;
  Framework.prototype.$message = Message;
}

module.exports = installManagementUi;
